import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EditVendorProfile from "../components/EditVendorProfile";

const EditVendorProfliePage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Edit Profile' />

                <EditVendorProfile />

            </MasterLayout>
        </>
    );
};

export default EditVendorProfliePage;
